module.exports = __webpack_public_path__ + "img/digest.3ef0a3cc.svg";